import { apiRequest } from "../../lib/api";

export interface KpiCard {
  id: string;
  titulo: string;
  valor: number;
  es_porcentaje: boolean;
  es_monto: boolean;
  delta_vs_anterior: number | null;
  delta_label: string | null;
  sublabel: string | null;
  tono: string;
}

export interface PuntoTendencia {
  label: string;
  valor: number;
}

export interface TendenciaSerie {
  titulo: string;
  descripcion: string | null;
  unidad: string;
  puntos: PuntoTendencia[];
  /** KPI al que acompaña como sparkline (id estable del backend). */
  kpi_id?: string | null;
}

export interface Alerta {
  id: string;
  /** Texto del botón (verbo + objeto). `null`: uno genérico por nivel. */
  accion?: string | null;
  titulo: string;
  detalle: string | null;
  cantidad: number | null;
  severidad: "critica" | "alta" | "media" | "baja";
  icono: string;
  href: string;
}

export interface ItemPorHacer {
  id: string;
  /** Texto del botón (verbo + objeto). `null`: uno genérico por nivel. */
  accion?: string | null;
  titulo: string;
  detalle: string | null;
  cantidad: number | null;
  icono: string;
  href: string;
  tono: string;
}

export interface TopDeudor {
  socio_id: number;
  socio_nombre: string;
  socio_numero: string | null;
  monto_deuda: number;
  boletas_vencidas: number;
  /** Nombre del sector representativo (uno de los sectores donde tiene
   *  contratos morosos). Null si no se pudo resolver. */
  sector_nombre: string | null;
  /** Meses transcurridos desde la lectura morosa más antigua del socio.
   *  Útil para priorizar cobranza/corte (≥2 meses ya es candidato). */
  antiguedad_meses: number | null;
  /** Vencimiento de la boleta impaga más antigua (YYYY-MM-DD): el semáforo
   *  mide el atraso desde acá, igual que Morosidad y la cuenta corriente. */
  vencimiento_mas_antiguo?: string | null;
  /** Contrato moroso del socio, sólo si es único (la deuda se agrega por
   *  socio pero el corte es por contrato). Null = varios contratos o ninguno
   *  resoluble → la UI no ofrece el corte de un click. */
  contrato_id: number | null;
  /** Estado de la orden de corte ACTIVA del contrato (Pendiente/Notificada/
   *  EnRuta/Cortada), o null si no tiene corte en proceso. */
  estado_corte: string | null;
}

export interface Sugerencia {
  id: string;
  /** Texto del botón (verbo + objeto). `null`: uno genérico por nivel. */
  accion?: string | null;
  titulo: string;
  detalle: string | null;
  cantidad: number | null;
  icono: string;
  href: string | null;
  tono: string;
}

export interface DashboardOperativoResponse {
  generado_en: string;
  periodo: string;
  kpis: KpiCard[];
  tendencias: TendenciaSerie[];
  alertas: Alerta[];
  por_hacer_hoy: ItemPorHacer[];
  sugerencias: Sugerencia[];
  top_deudores: TopDeudor[];
}

export function fetchDashboardOperativo(): Promise<DashboardOperativoResponse> {
  return apiRequest<DashboardOperativoResponse>(
    "/api/v1/dashboard/operativo",
  );
}
